import React, { useEffect, useState, useRef } from "react";
import useClickOutside from "../../hook/UseClickOutSide";
export interface SelectFileItemsType {
  files: any;
  onSelectFile: (file: any) => void;
  isReset?: boolean;
  selectFile?: string;
}
function SelectFileItems({
  files,
  onSelectFile,
  isReset = false,
  selectFile,
}: SelectFileItemsType) {
  const [selectedFile, setSelectedFile] = useState<string>("");
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOpenItems = (value: boolean) => {
    setIsOpen(value);
  };

  const handleClickItems = (value: string) => {
    setSelectedFile(value);
    onSelectFile(value);
    setIsOpen(false);
  };

  useClickOutside(dropdownRef, () => {
    setIsOpen(false);
  });

  useEffect(() => {
    setOptions(files);
  }, [files]);

  useEffect(() => {
    if (isReset) {
      setSelectedFile("");
      onSelectFile("");
    }
  }, [isReset]);

  useEffect(() => {
    if (selectFile) {
      setSelectedFile(selectFile);
    } else {
      setSelectedFile("");
    }
  }, [selectFile]);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex self-stretch pl-4 pr-2 h-10 bg-primary-contrast items-center rounded-xl border-[1px] border-gray-2"
        onClick={() => handleClickOpenItems(!isOpen)}
      >
        {selectedFile && selectedFile.trim() !== "" ? (
          <p className="w-full text-sm text-text-primary font-light">
            {selectedFile}
          </p>
        ) : (
          <p className="w-full text-sm text-text-disabled font-light">
            เลือกไฟล์ที่ต้องการ
          </p>
        )}

        <div className={`${isOpen && "-rotate-180"}`}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_904_68250)">
              <path
                d="M6.70978 9.30996C7.09978 8.91996 7.72978 8.91996 8.11978 9.30996L11.9998 13.19L15.8798 9.30996C16.2698 8.91996 16.8998 8.91996 17.2898 9.30996C17.6798 9.69996 17.6798 10.33 17.2898 10.72L12.6998 15.31C12.3098 15.7 11.6798 15.7 11.2898 15.31L6.69978 10.72C6.31978 10.34 6.31978 9.69996 6.70978 9.30996Z"
                fill="#8E8E8E"
              />
            </g>
            <defs>
              <clipPath id="clip0_904_68250">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="matrix(0 1 1 0 0 0)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      {isOpen && (
        <div className="w-full max-h-[300px]  overflow-y-auto z-10 absolute bg-primary-contrast p-2 border-[1px] mt-1 border-gray-2 rounded-2xl">
          {options.length > 0 ? (
            options.map((e: any) => (
              <div key={e.id} className="w-full cursor-pointer ">
                <p
                  onClick={() => handleClickItems(e.value)}
                  className="w-full text-sm py-1 pl-4 pr-2 text-text-primary font-light hover:bg-primary-light rounded-xl"
                >
                  {e.value}
                </p>
              </div>
            ))
          ) : (
            <p className="text-sm text-text-primary font-light text-center w-full">
              ไม่พบข้อมูล
            </p>
          )}
        </div>
      )}
    </div>
  );
}
export default SelectFileItems;
